/**
 * Sticky header functionality
 *
 * @package Embark
 * @since   1.0.0
 */

/**
 * Common variables used throughout the project.
 *
 * @since 1.0.0
 */
import $ from 'jquery';
import { els } from './variables';

/**
 * Tracks the current scroll position on the page.
 *
 * @type {Number}
 */
let currentScrollPoint;
let oldScroll;

/**
 * The point (in pixels) at which the header class should be toggled.
 *
 * @type {Number}
 */
// const headerScrollPoint = 100;

/**
 * Toggle the header scrolled class.
 *
 * @param  {Event} e
 */
function maybeToggleScrolledClass() {
	if (!els.header) {
		return;
	}

	/**
	 * Update the current scroll position.
	 *
	 * @type {Number}
	 */
	currentScrollPoint = (els.html && els.html.scrollTop) || els.body.scrollTop;
	let scrollPoint = 0;
	const navigator = document.querySelector('.ivy-navigator');

	scrollPoint = els.header.clientHeight - 95;

	/**
	 * Check scroll status and toggle .scrolled accordingly.
	 */
	if (currentScrollPoint > scrollPoint) {
		// console.log(scrollPoint);
		els.header.classList.add('scrolled');
		if (!navigator.classList.contains('open')) {
			navigator.classList.add('open');
			setTimeout(() => {
				navigator.classList.add('closed');
			}, 15000);
		}
	} else if (els.header.classList.contains('scrolled')) {
		els.header.classList.remove('scrolled');
	}

	if (oldScroll < els.body.scrollTop && els.header.classList.contains('scrolled')) {
		els.header.classList.add('scroll-down');
	} else {
		els.header.classList.remove('scroll-down');
	}

	oldScroll = window.scrollTop;
}

function maybeToggleScrolledLabMenu() {
	if (!els.header) {
		return;
	}

	/**
	 * Update the current scroll position.
	 *
	 * @type {Number}
	 */
	currentScrollPoint = (els.html && els.html.scrollTop) || els.body.scrollTop;

	/**
	 * Check scroll status for labs anchor menu and toggle .scrolled accordingly.
	 */
	if (els.labAnchor) {
		const labScrollPoint = els.header.clientHeight + els.masthead.clientHeight;
		const footerTop = $('.site-footer').offset().top;

		if (currentScrollPoint <= labScrollPoint || currentScrollPoint >= footerTop - 200) {
			els.labAnchor.classList.remove('scrolled-anchor');
			els.labAnchor.classList.remove('banner-padding');
		} else {
			els.labAnchor.classList.add('scrolled-anchor');
			if (document.cookie.indexOf('site-notice__optout') === -1) {
				els.labAnchor.classList.add('banner-padding');
			}
		}
	}

	if (oldScroll < els.body.scrollTop && els.header.classList.contains('scrolled')) {
		els.header.classList.add('scroll-down');
	} else {
		els.header.classList.remove('scroll-down');
	}

	oldScroll = window.scrollTop;
}

const setSitePadding = () => {
	// If mobile menu is shown do not add inline padding to the element.
	// Get the current viewport width
	const screenWidth = window.innerWidth;

	if (screenWidth > 1114) {
		const site = document.querySelector('.site');
		site.style.paddingTop = `${(els.header.clientHeight)}px`;
	}
};

window.addEventListener('scroll', () => {
	window.requestAnimationFrame(() => {
		maybeToggleScrolledClass();
		maybeToggleScrolledLabMenu();
	});
});

window.addEventListener('resize', () => {
	window.requestAnimationFrame(() => {
		setSitePadding();
	});
});

window.addEventListener('load', () => {
	setSitePadding();
	if (els.body.classList.contains('parent-pageid-5296')) {
		maybeToggleScrolledLabMenu();
	} else {
		maybeToggleScrolledClass();
	}
});
